// @flow
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/jquery-model3D/jquery.model3D';

export default class EshopModel3D extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.handleEscape = this.handleEscape.bind(this);
		this.destroyModel = this.destroyModel.bind(this);
	}
	enterDocument() {
		const {
			opener,
			closer,
		} = this.props;

		document.querySelector(opener).addEventListener('click', this.handleClick);
		const closerLinks = document.querySelectorAll(closer);
		Array.from(closerLinks).forEach(link => {
			link.addEventListener('click', this.destroyModel);
		});

		document.addEventListener('keyup', this.handleEscape);
		window.active3DModel = null;
	}

	handleClick(e) {
		const {
			images,
			closer,
			parentContainer,
			removeActiveLink,
		} = this.props;

		e.preventDefault();

		const closerLinks = document.querySelectorAll(closer);

		// used for destroying any zoomed image active
		$(document).trigger('EDEESHOP_PHOTOGALLERY_PHOTO_CHANGE');

		this.parentContainer = document.querySelector(parentContainer);
		this.parentContainer.classList.add('eshop-gallery--with-model3d');
		this.parentContainer.classList.add('with-model3d');
		this.opener = e.target;
		this.opener.classList.add('active');

		if (removeActiveLink) {
			Array.from(closerLinks).forEach(link => {
				link.parentNode.classList.remove('active');
			});
		}

		window.active3DModel = $(this.element).model3D({
			data: images,
			width: 450,
			height: 450,
		});

		this.removeBtn = document.createElement('div');
		this.removeBtn.classList.add('model3d-remove');
		this.removeBtn.addEventListener('click', this.destroyModel);
		this.element.appendChild(this.removeBtn);
	}

	destroyModel() {
		if ((window.active3DModel) && (window.active3DModel.data('plugin_model3D'))) {
			window.active3DModel.data('plugin_model3D').destroy();
			this.parentContainer.classList.remove('eshop-gallery--with-model3d');
			this.parentContainer.classList.remove('with-model3d');
			this.opener.classList.remove('active');
			window.active3DModel = null;

			if (this.removeBtn) {
				this.removeBtn.parentNode.removeChild(this.removeBtn);
			}
		}
	}

	// deactivate on escape key
	handleEscape(e) {
		const $modelObject = window.active3DModel;
		// 27 = escape
		if ($modelObject instanceof $ && e.which == 27) {
			window.active3DModel = null;
		}
	};

  willUnMount() {
    this.destroyModel();
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/EshopModel3D.js